import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AccountProfileResponse } from 'src/app/models/account-profile-response.model'

@Injectable({
  providedIn: 'root',
})
export class AccountProfileService {
  public static readonly accountProfileEndpoint = '/accountProfile'

  constructor(private readonly http: HttpClient) {}

  getAccountProfile(fundId: string): Observable<AccountProfileResponse> {
    return this.http.get<AccountProfileResponse>(
      `vmf/api/${fundId}`.concat(AccountProfileService.accountProfileEndpoint),
    )
  }
}
